import styled from '@emotion/styled/macro';

const Prize = styled.img`
    display: block;
    width: 100%;
    max-width: 350px;
    height: auto;
    margin: 20px auto 16px auto;
`;

export default Prize;
